import axios from "axios";

export async function showPaymentPortal(
  stripe_id: string,
  promo_code?: string
) {
  // Custom checkout appearance to match enterprise UI
  const checkoutAppearance = {
    theme: 'stripe',
    variables: {
      colorPrimary: '#9300DA', // Grocerize purple
      colorBackground: '#ffffff',
      colorText: '#333333',
      colorDanger: '#ff5252',
      fontFamily: 'Inter, system-ui, sans-serif',
      spacingUnit: '4px',
      borderRadius: '6px'
    },
    rules: {
      '.Tab': {
        border: '1px solid #e6e6e6',
        borderRadius: '6px'
      },
      '.Tab:hover': {
        border: '1px solid #9300DA'
      },
      '.Tab--selected': {
        borderColor: '#9300DA',
        boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)'
      },
      '.Label': {
        fontWeight: '500'
      },
      '.Input': {
        borderRadius: '6px',
        border: '1px solid #e6e6e6'
      }
    }
  };
  
  await axios
    .post(
      process.env.REACT_APP_BACKEND_URL + "/payments/create-checkout-session",
      {
        lookup_key: process.env.REACT_APP_STRIPE_PRICE_LOOKUP_KEY,
        customer: stripe_id,
        promo_code: promo_code,
        custom_appearance: checkoutAppearance,
        custom_branding: {
          logo: `${window.location.origin}/images/grocerize-premium-logo.svg`, // Make sure this asset exists
          primary_color: '#9300DA', // Grocerize purple
          brand_name: 'Grocerize Premium'
        }
      }
    )
    .then((data) => {
      window.location.replace(data.data.url);
    })
    .catch((e) => {
      console.error("Error creating checkout session:", e);
      alert("There was an error redirecting to checkout. Please try again.");
    });
}
